import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISiteState } from 'src/types/Site';

const initialState: ISiteState = {
  selectedSite: null,
  selectedStudy: null,
  selectedCountry: null,
  selectedSiteRole: null,
  siteClicksData: null,
  sitePermissionData: null,
  currentHierarchyLevel: null,
  isHierarchyLevelClosed: false,
  userAccessData: {},
  siteInfo: null
};

export const site = createSlice({
  name: 'site',
  initialState,
  reducers: {
    clearSite: state => {
      state.selectedSite = null;
      state.selectedSiteRole = null;
    },
    setSite: (state, action: PayloadAction<string | null>) => {
      state.selectedSite = action.payload;
    },
    clearStudy: state => {
      state.selectedStudy = null;
    },
    setStudy: (state, action: PayloadAction<string | null>) => {
      state.selectedStudy = action.payload;
    },
    setCountry: (state, action: PayloadAction<string | null>) => {
      state.selectedCountry = action.payload;
    },
    clearCountrySiteOnly: state => {
      state.selectedCountry = null;
      state.selectedSite = null;
    },
    clearSiteOnly: state => {
      state.selectedSite = null;
    },
    clearCountrySite: state => {
      state.selectedCountry = null;
      state.selectedSite = null;
      state.selectedSiteRole = null;
    },
    clearStudySite: state => {
      state.selectedStudy = null;
      state.selectedCountry = null;
      state.selectedSite = null;
      state.selectedSiteRole = null;
    },
    setSiteRole: (state, action: PayloadAction<string | null>) => {
      state.selectedSiteRole = action.payload;
    },
    clearSiteRole: state => {
      state.selectedSiteRole = null;
    },
    setSiteClicksData: (state, action: PayloadAction<string>) => {
      state.siteClicksData = action.payload;
    },
    clearSiteClicks: state => {
      state.siteClicksData = null;
    },
    setSitePermissionData: (state, action: PayloadAction<boolean>) => {
      state.sitePermissionData = action.payload;
    },
    setCurrentHierarchyLevel: (state, action: PayloadAction<string | null>) => {
      state.currentHierarchyLevel = action.payload;
    },
    setHierarchyLevelClosed: (state, action: PayloadAction<boolean>) => {
      state.isHierarchyLevelClosed = action.payload;
    },
    setUserAccessData: (state, action: PayloadAction<any>) => {
      state.userAccessData = action.payload;
    },
    setSiteInfo: (state, action: PayloadAction<string | null>) => {
      state.siteInfo = action.payload;
    }
  }
});

export const {
  clearSite,
  setSite,
  clearStudySite,
  setStudy,
  setCountry,
  clearStudy,
  setSiteRole,
  clearSiteRole,
  setSiteClicksData,
  setSitePermissionData,
  clearCountrySite,
  setCurrentHierarchyLevel,
  setHierarchyLevelClosed,
  setUserAccessData,
  clearCountrySiteOnly,
  clearSiteOnly,
  setSiteInfo
} = site.actions;
